import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "w100p"
  }, [_c("div", [!_vm.updatingQuotationStatus.isConfiguring ? [_c("div", {
    staticClass: "d-flex"
  }, [_c("div", {
    staticClass: "badge --small",
    class: _vm.quotationStatusClass
  }, [_vm._v(" " + _vm._s(_vm.quotationStatusLabel) + " ")]), _c(VIcon, {
    staticClass: "fa fa-pen ml-1 icon-linkr",
    attrs: {
      size: "0.65rem"
    },
    on: {
      click: _vm.startEditQuotationStatus
    }
  })], 1)] : [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.quotationStatusList,
      "item-value": "id",
      "item-text": "name",
      dense: "",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: _vm.udpateQuotationStatus
    },
    model: {
      value: _vm.updatingQuotationStatus.form.quotationStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingQuotationStatus.form, "quotationStatus", $$v);
      },
      expression: "updatingQuotationStatus.form.quotationStatus"
    }
  })]], 2), _c("div", {
    staticClass: "mt-1"
  }, [_c(VTextarea, {
    staticClass: "v-textarea-cm",
    attrs: {
      dense: "",
      outlined: "",
      placeholder: "No comment",
      rows: "1",
      "auto-grow": "",
      "no-resize": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.updatingComment.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingComment.form, "comment", $$v);
      },
      expression: "updatingComment.form.comment"
    }
  }), _c("div", {
    staticClass: "text-right"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      loading: _vm.updatingComment.isPending
    },
    on: {
      click: _vm.udpateComment
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save comment ")], 1)], 1)], 1), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };